import React from 'react';
import ButtonLink from "@atoms/button.link";
import {useWindowSize} from "@helpers/windows.size";
import Icon from "@atoms/icon";
import ChevronLeftIcon from '@icons/chevron-left.svg';

const LandingSeeMorePropertyBtn = ({hrefAs}) => {
    const windowSize = useWindowSize();

    return (
        <ButtonLink
            className="btn-sm-block"
            href="/properties"
            hrefAs={hrefAs}
            color="primary"
            variant="outline"
            size={windowSize < 992 ? "" : "sm"}
        >
            <span>مشاهده بیشتر</span>
            <Icon width="7" height="11" className="mr-8"><ChevronLeftIcon/></Icon>
        </ButtonLink>
    );
};

export default React.memo(LandingSeeMorePropertyBtn);
